import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import { FaFileContract, FaCheckCircle, FaGlobeAsia, FaUserCheck, FaCreditCard, FaUndoAlt, FaEdit, FaPassport, FaBalanceScale, FaUserShield, FaGavel, FaSyncAlt, FaPhoneAlt } from "react-icons/fa";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";

export default function TermsandConditions() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* NavbarSticky */}
            <Navbarsticky/>
            <div className="terms-container">
            </div>

            {/* MAIN CONTENT */}
            <div className="terms-section py-5 w-100">
                <Container fluid className="w-100">
                    <Row className="justify-content-center">
                        <h1 className="terms-title">
                            <FaFileContract className="title-icon" />
                            Terms and Conditions
                        </h1>
                        <Col lg={9} md={11}>
                            <div className="terms-card">
                                 <p className="terms-subtitle">Last Updated: on</p>
                                <p>
                                    Welcome to <strong>https://amh.octaloptimum.in/</strong>
                                    (“we”, “our”, “us”). These Terms and Conditions govern your
                                    use of our website and services for booking travel packages and
                                    related services.
                                </p>

                                {/* 1. Acceptance of Terms */}
                                <div className="terms-block">
                                    <h5><FaCheckCircle className="block-icon" /> Acceptance of Terms</h5>
                                </div>

                                <p>
                                    By accessing or using our website or services, you agree to be
                                    bound by these Terms. If you do not agree with any part, you
                                    may not use the service.
                                </p>

                                {/* 2. Services Offered */}
                                <div className="terms-block">
                                    <h5><FaGlobeAsia className="block-icon" /> Services Offered</h5>
                                </div>

                                <p>
                                    We offer curated travel packages which may include
                                    accommodation, transport, tours, activities, and more.
                                </p>

                                <p>
                                    All bookings are subject to availability and confirmation by
                                    <strong> https://amh.octaloptimum.in/ </strong> and partners.
                                </p>

                                {/* 3. Eligibility */}
                                <div className="terms-block">
                                    <h5><FaUserCheck className="block-icon" /> Eligibility</h5>
                                </div>

                                <p>
                                    You must be at least 18 years of age to make a booking. By
                                    using our services, you confirm you have legal capacity.
                                </p>

                                {/* 4. Booking & Payment */}
                                <div className="terms-block">
                                    <h5><FaCreditCard className="block-icon" /> Booking and Payment</h5>
                                </div>

                                <ul>
                                    <li>Full or partial payment must be made to confirm a booking.</li>
                                    <li>Payments are securely processed via third-party gateways.</li>
                                    <li>In case of payment failure, bookings will not be confirmed.</li>
                                    <li>Pricing may change based on availability and timing.</li>
                                </ul>

                                {/* 5. Cancellation & Refund */}
                                <div className="terms-block">
                                    <h5><FaUndoAlt className="block-icon" /> Cancellation and Refund Policy</h5>
                                </div>

                                <ul>
                                    <li>Cancellations must be submitted in writing or via your account.</li>
                                    <li>Refunds follow package-specific terms.</li>
                                    <li>Non-refundable packages will be labeled clearly.</li>
                                    <li>Refunds may take 7–14 business days.</li>
                                </ul>

                                {/* 6. Modifications */}
                                <div className="terms-block">
                                    <h5><FaEdit className="block-icon" /> Modification of Bookings</h5>
                                </div>

                                <ul>
                                    <li>Modifications depend on availability and provider approval.</li>
                                    <li>Changes to dates, names, or details may incur charges.</li>
                                </ul>

                                {/* 7. Travel Documents */}
                                <div className="terms-block">
                                    <h5><FaPassport className="block-icon" /> Travel Documents</h5>
                                </div>

                                <p>
                                    You are responsible for required travel documents including
                                    passports, visas, and health certificates.
                                </p>

                                {/* 8. Liability Disclaimer */}
                                <div className="terms-block">
                                    <h5><FaBalanceScale className="block-icon" /> Liability Disclaimer</h5>
                                </div>

                                <p>We are not liable for:</p>

                                <ul>
                                    <li>Acts or omissions by third-party vendors</li>
                                    <li>Service disruptions due to force majeure events</li>
                                    <li>Loss, damage, or injury during travel</li>
                                </ul>

                                {/* 9. User Responsibilities */}
                                <div className="terms-block">
                                    <h5><FaUserShield className="block-icon" /> User Responsibilities</h5>
                                </div>

                                <ul>
                                    <li>Provide accurate information during booking.</li>
                                    <li>Follow all travel and safety guidelines.</li>
                                    <li>No reselling or misuse of travel packages.</li>
                                </ul>

                                {/* 10. Intellectual Property */}
                                <div className="terms-block">
                                    <h5><FaFileContract className="block-icon" /> Intellectual Property</h5>
                                </div>

                                <p>
                                    All website content, branding, and materials are our
                                    intellectual property and cannot be reused without written
                                    permission.
                                </p>

                                {/* 11. Dispute Resolution */}
                                <div className="terms-block">
                                    <h5><FaGavel className="block-icon" /> Dispute Resolution</h5>
                                </div>

                                <p>
                                    Disputes will first be handled informally. If unresolved, they
                                    fall under the jurisdiction of courts in Port Blair, Andaman &
                                    Nicobar Islands.
                                </p>

                                {/* 12. Changes to Terms */}
                                <div className="terms-block">
                                    <h5><FaSyncAlt className="block-icon" /> Changes to Terms</h5>
                                </div>

                                <p>
                                    We may update these Terms anytime. Continued use of the site
                                    indicates acceptance of the revised terms.
                                </p>

                                {/* 13. Contact Information */}
                                <div className="terms-block">
                                    <h5><FaPhoneAlt className="block-icon" /> Contact Information</h5>
                                </div>

                                <p>
                                    For queries:<br />
                                    Email: andamanmakeholidayss@gmail.com<br />
                                    Phone: +91-8145080001
                                </p>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Footer */}
            <Footer/>
        </>
    );
}
